/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	Chip,
	Skeleton,
	Typography,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShipmentsOrder, getShipmentsOrderIsLoad } from 'redux/reducers/shipments/selectors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { updateOrderFieldValuesRequest } from 'redux/reducers/shipments/reducer';
import { EditableField } from './EditableField';

const buildValidationPattern = (expression: string | null | undefined): RegExp | null => {
	if (!expression) return null;
	try {
		return new RegExp(expression);
	} catch {
		return null;
	}
};

export const DeliveryInformation: FC = () => {
	const dispatch = useDispatch();
	const order = useSelector(getShipmentsOrder);
	const orderIsLoading = useSelector(getShipmentsOrderIsLoad);

	const editableFirstName = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'recipient_first_name',
	);
	const editableLastName = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'recipient_last_name',
	);
	const editableEmail = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_email',
	);
	const editablePhone = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_phone',
	);
	const editableCity = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_city',
	);
	const editableAddressLine1 = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_address_line_1',
	);
	const editableAddressLine2 = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_address_line_2',
	);
	const editableZipCode = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_postal_code',
	);
	const editableProvince = order?.fieldsConfig.find(
		(field) => field.tableFieldName === 'delivery_state_province',
	);

	const [firstName, setFirstName] = useState('');
	const [firstNameError, setFirstNameError] = useState('');
	const [lastName, setLastName] = useState('');
	const [lastNameError, setLastNameError] = useState('');
	const [email, setEmail] = useState('');
	const [emailError, setEmailError] = useState('');
	const [phone, setPhone] = useState('');
	const [phoneError, setPhoneError] = useState('');
	const [city, setCity] = useState('');
	const [cityError, setCityError] = useState('');
	const [addressLine1, setAddressLine1] = useState('');
	const [addressLine1Error, setAddressLine1Error] = useState('');
	const [addressLine2, setAddressLine2] = useState('');
	const [addressLine2Error, setAddressLine2Error] = useState('');
	const [zipCode, setZipCode] = useState('');
	const [zipCodeError, setZipCodeError] = useState('');
	const [province, setProvince] = useState('');
	const [provinceError, setProvinceError] = useState('');

	const handleFirstNameValidate = (value: string) => {
		if (!value) {
			setFirstNameError('First Name is required');
		} else if (value.length < 2) {
			setFirstNameError('First Name need to be at least 2 characters');
		} else {
			setFirstNameError('');
		}
		setFirstName(value);
	};

	const handleUpdateFirstName = () => {
		// dispatch(updateFirstName({ orderId: order?.order.id, firstName }));
	};

	const handleLastNameValidate = (value: string) => {
		if (!value) {
			setLastNameError('Last Name is required');
		} else if (value.length < 2) {
			setLastNameError('Last Name need to be at least 2 characters');
		} else {
			setLastNameError('');
		}
		setLastName(value);
	};

	const handleUpdateLastName = () => {
		// dispatch(updateLastName({ orderId: order?.order.id, lastName }));
	};

	const handleEmailValidate = (value: string) => {
		if (!value) {
			setEmailError('Email is required');
		} else if (!value.includes('@')) {
			setEmailError('Email is not valid');
		} else {
			setEmailError('');
		}
		setEmail(value);
	};

	const handleUpdateEmail = () => {
		// dispatch(updateEmail({ orderId: order?.order.id, email }));
	};

	const handlePhoneValidate = (value: string) => {
		if (!value) {
			setPhoneError('Phone is required');
		} else if (value.length < 5) {
			setPhoneError('Phone need to be at least 5 characters');
		} else {
			setPhoneError('');
		}
		setPhone(value);
	};

	const handleUpdateValues = () => {
		if (!order?.order.id) return;
		const fieldValuesArray = { fieldValues: {}, orderId: order?.order.id };
		if (editableFirstName?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableFirstName.tableFieldName] = firstName;
		}
		if (editableLastName?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableLastName.tableFieldName] = lastName;
		}
		if (editableEmail?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableEmail.tableFieldName] = email;
		}
		if (editablePhone?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editablePhone.tableFieldName] = phone;
		}
		if (editableCity?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableCity.tableFieldName] = city;
		}
		if (editableAddressLine1?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableAddressLine1.tableFieldName] = addressLine1;
		}
		if (editableAddressLine2?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableAddressLine2.tableFieldName] = addressLine2;
		}
		if (editableZipCode?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableZipCode.tableFieldName] = zipCode;
		}
		if (editableProvince?.tableName) {
			// @ts-ignore
			fieldValuesArray.fieldValues[editableProvince.tableFieldName] = province;
		}

		dispatch(updateOrderFieldValuesRequest(fieldValuesArray));
	};

	useEffect(() => {
		if (editableFirstName) {
			setFirstName(editableFirstName.value);
		}
		if (editableLastName) {
			setLastName(editableLastName.value);
		}
		if (editablePhone) {
			setPhone(editablePhone.value);
		}
		if (editableEmail) {
			setEmail(editableEmail.value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [order]);

	return (
		<div>
			{order && !orderIsLoading ? (
				<Card
					sx={{
						mb: 2,
						'&': {
							borderRadius: '12px',
						},
					}}
				>
					<CardContent>
						<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
							Delivery Information
						</Typography>
						{order?.order?.valuesStatus === 'Unprocessed' && (
							<>
								<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
									{editableFirstName && (
										<EditableField
											firstValue={order?.order.recipientFirstName}
											label="First Name"
											// onChange={handleUpdateLastName}
											value={firstName}
											error={firstNameError}
											setValue={setFirstName}
											setError={setFirstNameError}
											isRequired
											validationPattern={buildValidationPattern(
												editableFirstName?.regularExpression,
											)}
											errorComment={editableFirstName?.comment}
										/>
									)}

									{editableLastName && (
										<EditableField
											firstValue={order?.order.recipientLastName}
											label="Last Name"
											// onChange={handleUpdateLastName}
											value={lastName}
											error={lastNameError}
											setValue={setLastName}
											setError={setLastNameError}
											isRequired
											validationPattern={buildValidationPattern(
												editableLastName?.regularExpression,
											)}
											errorComment={editableLastName?.comment}
										/>
									)}
								</Box>
								{(editableEmail || editablePhone) && (
									<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
										{editableEmail && (
											<EditableField
												firstValue={order?.order.deliveryEmail}
												label="Email"
												type="email"
												// onChange={handleUpdateEmail}
												value={email}
												error={emailError}
												setValue={setEmail}
												setError={setEmailError}
												isRequired
												validationPattern={buildValidationPattern(editableEmail.regularExpression)}
												errorComment={editableEmail.comment}
											/>
										)}
										{editablePhone && (
											<EditableField
												firstValue={editablePhone.value}
												label="Phone"
												type="phone"
												// onChange={handleUpdatePhone}
												value={phone}
												error={phoneError}
												setValue={setPhone}
												setError={setPhoneError}
												isRequired
												validationPattern={buildValidationPattern(editablePhone.regularExpression)}
												errorComment={editablePhone.comment}
											/>
										)}
										{(!editableEmail || !editablePhone) && <div style={{ width: '100%' }}> </div>}
									</Box>
								)}
								{editableCity && (
									<Box sx={{ display: 'flex' }}>
										<EditableField
											firstValue={order?.order.deliveryCity}
											label="City"
											// onChange={handleUpdateCity}
											value={city}
											error={cityError}
											setValue={setCity}
											setError={setCityError}
											isRequired
											validationPattern={buildValidationPattern(editableCity.regularExpression)}
											errorComment={editableCity.comment}
										/>
									</Box>
								)}
								{editableAddressLine1 && (
									<Box sx={{ display: 'flex' }}>
										<EditableField
											firstValue={order?.order.deliveryAddressLine1}
											label="Address Line 1"
											// onChange={handleUpdateAddressLine1}
											value={addressLine1}
											error={addressLine1Error}
											setValue={setAddressLine1}
											setError={setAddressLine1Error}
											isRequired
											validationPattern={buildValidationPattern(
												editableAddressLine1.regularExpression,
											)}
											errorComment={editableAddressLine1.comment}
										/>
									</Box>
								)}
								{editableAddressLine2 && (
									<Box sx={{ display: 'flex' }}>
										<EditableField
											firstValue={order?.order.deliveryAddressLine2}
											label="Address Line 2"
											// onChange={handleUpdateAddressLine2}
											value={addressLine2}
											error={addressLine2Error}
											setValue={setAddressLine2}
											setError={setAddressLine2Error}
											validationPattern={buildValidationPattern(
												editableAddressLine2.regularExpression,
											)}
											errorComment={editableAddressLine2.comment}
											isRequired={false}
										/>
									</Box>
								)}
								{(editableZipCode || editableProvince) && (
									<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
										{editableZipCode && (
											<EditableField
												firstValue={order?.order.deliveryPostalCode}
												label="Zip Code"
												// onChange={handleUpdateZipCode}
												value={zipCode}
												error={zipCodeError}
												setValue={setZipCode}
												setError={setZipCodeError}
												isRequired
												validationPattern={buildValidationPattern(
													editableZipCode.regularExpression,
												)}
												errorComment={editableZipCode.comment}
											/>
										)}
										{editableProvince && (
											<EditableField
												firstValue={order?.order.deliveryStateProvince}
												label="Province"
												// onChange={handleUpdateProvince}
												value={province}
												error={provinceError}
												setValue={setProvince}
												setError={setProvinceError}
												validationPattern={buildValidationPattern(
													editableProvince.regularExpression,
												)}
												errorComment={editableProvince.comment}
												isRequired={false}
											/>
										)}
									</Box>
								)}
							</>
						)}

						{(!editableFirstName ||
							!editableLastName ||
							order?.order?.valuesStatus !== 'Unprocessed') && (
							<>
								<Typography sx={{ mt: 1.5 }} color="text.secondary">
									Customer:
								</Typography>
								<Typography variant="h6" component="div">
									{order?.order.deliveryPerson}
								</Typography>
							</>
						)}

						{order?.order.recipientCompanyName && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Company name:
								</Typography>
								<Typography>{order?.order.recipientCompanyName}</Typography>
							</>
						)}
						{order?.order.recipientCompanyVat && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Company VAT number:
								</Typography>
								<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
									<Typography>{order?.order.recipientCompanyVat}</Typography>
									<Chip
										label={order?.order.recipientCompanyVatValidated?.replace('_', ' ')}
										// variant="outlined"
										color={
											order?.order.recipientCompanyVatValidated === 'not_validated'
												? 'warning'
												: 'success'
										}
										size="small"
										sx={{
											p: '0 5px',
											ml: 1,
											fontSize: '.7rem',
											height: '20px',
											// fontWeight: 'bold',
										}}
									/>
								</Box>
							</>
						)}
						{(!editableEmail || order?.order?.valuesStatus !== 'Unprocessed') && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Email:
								</Typography>
								<Typography>{order?.order.deliveryEmail || '—'}</Typography>{' '}
							</>
						)}

						{(!editablePhone || order?.order?.valuesStatus !== 'Unprocessed') && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Phone number:
								</Typography>
								<Typography>{order?.order.deliveryPhone || '—'}</Typography>{' '}
							</>
						)}

						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Country:
						</Typography>
						<CountryWithFlag countryCode={order?.order.deliveryCountry} />

						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Address:
						</Typography>
						<Typography>{order?.order.deliveryAddress}</Typography>

						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Cost:
						</Typography>
						<AmountAndCurrency
							amount={order?.order.deliveryCost ?? 0}
							currency={order?.order.paymentCurrency}
							size={1}
						/>
					</CardContent>
					{order?.order?.valuesStatus === 'Unprocessed' && (
						<CardActions>
							<Button
								variant="contained"
								color="primary"
								size="small"
								sx={{
									borderRadius: '12px!important',
									textTransform: 'none',
									maxHeight: '24px',
									// width: '100%',
								}}
								disabled={
									!!firstNameError ||
									!!lastNameError ||
									!!emailError ||
									!!phoneError ||
									!!cityError ||
									!!addressLine1Error ||
									!!addressLine2Error ||
									!!zipCodeError ||
									!!provinceError ||
									((editableFirstName?.value ?? '') === firstName &&
										(editableLastName?.value ?? '') === lastName &&
										(editableEmail?.value ?? '') === email &&
										(editablePhone?.value ?? '') === phone &&
										(editableCity?.value ?? '') === city &&
										(editableAddressLine1?.value ?? '') === addressLine1 &&
										(editableAddressLine2?.value ?? '') === addressLine2 &&
										(editableZipCode?.value ?? '') === zipCode &&
										(editableProvince?.value ?? '') === province)
								}
								onClick={handleUpdateValues}
							>
								Update Delivery Information
							</Button>
						</CardActions>
					)}
				</Card>
			) : (
				<Skeleton variant="rectangular" height="300px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
